exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body {\n  padding: 2.5rem 2rem; }\n\n.checkbox-group {\n  color: #8b8b8b;\n  font-family: \"RobotoMedium\", sans-serif;\n  font-size: 2rem;\n  margin: 1rem 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/pages/companies/create-group-modal/create-group.component.scss
// module id = ../../../../../src/app/pages/companies/create-group-modal/create-group.component.scss
// module chunks = 2